<template>
    <div class="coverbloc" id="coverbloc">
        <div id="coverinfocontainer" class="coverinfocontainer">
             <CoverDetails v-if="showDetailClaim"/>
             <SubmitClaim  v-if="showSubmitClaim" ref="claimform"/>
             <SubmitClaimSummary  v-if="showSubmitClaimSummary" ref="claimSummary"/>
        </div>
        <div class="coverfooterbloc">
            <v-layout row class="submitclaimbtnbloc">
                <v-flex  xs10 offset-xs1>
                    <v-layout row v-if="canClaimAndSettleCover">
                        <v-flex xs6 class="footeractionleft" v-if="canClaimCover">
                            <v-btn color="primary" class="fullsize" @click="submitClaim">{{$t('Cover.ShowCover.SUBMIT_CLAIM_BTN')}}</v-btn>
                        </v-flex>
                        <v-flex :xs6="canClaimCover" :x12="!canClaimCover" class="footeractionright">
                            <v-btn color="primary" class="fullsize" @click="settleCover">{{$t('Cover.ShowCover.SETTLE_THE_COVER_BTN')}}</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-btn v-if="canSettleCover && !canClaimAndSettleCover" color="primary" class="fullsize" @click="settleCover">{{$t('Cover.ShowCover.SETTLE_THE_COVER_BTN')}}</v-btn>
                    <v-btn v-if="canClaimCover && showSubmitClaim" color="primary" class="fullsize" @click="submitClaimSummary">Next</v-btn>
                    <v-layout row v-if="canClaimCover && showSubmitClaimSummary">
                         <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
                        <v-flex xs6 class="footeractionleft">
                            <v-btn v-if="showSubmitClaimSummary" :disabled="btndisabled"  class="fullsize custombtn" @click="backToClaimForm">{{$t('Claim.RequestClaim.SUMMARY_BACK_BTN')}}</v-btn>
                        </v-flex>
                        <v-flex xs6 class="footeractionright">
                            <v-btn v-if="showSubmitClaimSummary" :disabled="btndisabled"  color="primary" class="fullsize" @click="submitClaimCommit">{{$t('Claim.RequestClaim.SUMMARY_SUBMIT_CLAIM_BTN')}}</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="canActivateCover && !loadingActivate">
                        <v-flex xs6 class="footeractionleft">
                            <v-btn color="primary" class="fullsize" @click="activateCover">{{$t('Cover.ShowCover.ACTIVATE_COVER_BTN')}}</v-btn>
                        </v-flex>
                        <v-flex xs6 class="footeractionright">
                            <v-btn color="primary" class="fullsize" @click="rejectCover">{{$t('Cover.ShowCover.REFUSE_COVER_BTN')}}</v-btn>
                        </v-flex>
                    </v-layout>
                    <div v-if="canActivateCover && loadingActivate" class="text-xs-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import CoverDetails from '@/components/cover/details/CoverDetails'
import SubmitClaim from '@/components/cover/claim/SubmitClaim'
import SubmitClaimSummary from '@/components/cover/claim/SubmitClaimSummary'
import coverApi from '@/services/CoverApi'
import auth from '@/services/Auth'
import constants from '@/constants/index'

export default {
  data () {
    return {
      showDetailClaim: true,
      showSubmitClaim: false,
      showSubmitClaimSummary: false,
      claimableStatuses: [constants.CoverStatus.LATE, constants.CoverStatus.ACTIVATED],
      settleableStatuses: [constants.CoverStatus.LATE, constants.CoverStatus.ACTIVATED, constants.CoverStatus.CLAIMED, constants.CoverStatus.TIMEBARRED],
      loading: false,
      loadingActivate: false,
      btndisabled: false,
      externalId: '',
      snackbar: {
        show: false,
        color: 'success',
        text: 'Success! Your claim has been submitted',
        timeout: 6000
      },
      fileInvoiceDocumentType: 'Invoice',
      fileProofOfDeliveryDocumentType: 'ProofOfDelivery',
      filePurchaseOrderDocumentType: 'PurchaseOrder',
      filePowerOfAttorneyDocumentType: 'PowerOfAttorney',
      createClaimSuccessText: this.$t('Claim.RequestClaim.SUCCESSFUL_CLAIM_SUBMISSION_DESC'),
      activateCoverSuccessText: this.$t('Cover.ShowCover.COVER_ACIVATED_DESC'),
      rejectCoverSuccessText: 'Your cover has been refused',
      pendingStatus: 'Pending'
    }
  },
  methods: {
    submitClaim () {
      $('#coverinfocontainer').scrollTop(0)
      this.showDetailClaim = false
      this.showSubmitClaim = true
      this.disablebloc()
    },
    submitClaimSummary () {
      $('#coverinfocontainer').scrollTop(0)
      this.$refs.claimform.submitClaimNextStep()
    },
    activeClaimSummary () {
      this.showDetailClaim = false
      this.showSubmitClaim = false
      this.showSubmitClaimSummary = true
    },
    backToClaimForm () {
      this.showDetailClaim = false
      this.showSubmitClaim = true
      this.showSubmitClaimSummary = false
    },
    async submitClaimCommit () {
      this.loading = true
      this.btndisabled = true
      var formData = new FormData()
      var allfiles = this.$concatArrays(this.submittedClaim.documents.map((d) => { return d.files }))

      for (var i = 0; i < allfiles.length; i++) {
        let file = allfiles[i]
        formData.append('attachments[' + i + ']', file)
      }

      let contacts = {
        creditor: {
          contactInformation: this.userInfos.claimExtendedForm ? this.contactInfo(this.submittedClaim.seller) : this.creditorInfo()
        },
        debtor: {
          contactInformation: this.contactInfo(this.submittedClaim.buyer)
        }
      }

      var claimformInfo = {
        contacts: contacts,
        claimContextInfo: this.contextClaimInfo(),
        claimDocumentsInfo: this.claimDocumentsInfo()
      }
      formData.append('claim', JSON.stringify(claimformInfo))
      let succes = await coverApi.createsubmitClaim(formData, this.cover.details.id)

      this.loading = false
      this.btndisabled = false
      if (succes) {
        this.setSnackbarValues(true, 'success', this.createClaimSuccessText)
        this.$refs.claimSummary.closeExtendedMode()
        if (this.cover.invoice.status === 'Late') { this.$store.dispatch('coverlate/getCoversLate') }
        if (this.cover.invoice.status === 'Activated') {
          this.$store.dispatch('coveractivated/getCoversActivated')
          this.$store.dispatch('listcovertabs/updateCoversLateCount')
        }

        this.$store.dispatch('listcovertabs/updateCoversClaimedCount')
        this.$store.dispatch('global/setSnackbar', this.snackbar)
      } else {
        this.$refs.claimSummary.error = true
      }
    },
    contactInfo (contact) {
      return {
        firstName: contact.firstName,
        lastName: contact.lastName,
        officePhone: contact.officePhone,
        mobilePhone: contact.mobilePhone,
        email: contact.email,
        fax: ''
      }
    },
    creditorInfo () {
      let userInfo = auth.getUserInfos()
      return {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        officePhone: '',
        mobilePhone: '',
        email: userInfo.email,
        fax: ''
      }
    },
    contextClaimInfo () {
      return {
        referenceNumber: this.submittedClaim.clientRefNumber,
        isInvoiceDisputed: this.submittedClaim.invoicedisputedValue,
        isInsolvencyProceeding: this.submittedClaim.buyerinsolvencyValue,
        comment: this.submittedClaim.comment,
        collectedAmount: this.userInfos.claimSettings.showCollectedAmount ? this.submittedClaim.collectedAmount : null,
        amountWithoutVAT: this.submittedClaim.amountWithoutVAT,
        fundedAmount: this.userInfos.claimExtendedForm ? this.submittedClaim.fundedAmount : null,
        deliveryDate: this.userInfos.claimSettings.showDeliveryDate ? this.submittedClaim.deliveryDate : null
      }
    },
    claimDocumentsInfo () {
      return this.$concatArrays(this.submittedClaim.documents.map((d) => { return this.getDocumentsMap(d.files, d.fileType) }))
    },
    getDocumentsMap (filesList, documentType) {
      return filesList.map((file) => {
        return {
          fileName: file.name,
          documentType: documentType
        }
      })
    },
    initializeCreateClaim () {
      this.showDetailClaim = false
      this.showSubmitClaim = true
      this.showSubmitClaimSummary = false
      this.disablebloc()
      let submittedClaim = {
        buyer: {
          firstName: '',
          lastName: '',
          email: '',
          mobilePhone: '',
          officePhone: ''
        },
        seller: {
          firstName: '',
          lastName: '',
          email: '',
          mobilePhone: '',
          officePhone: ''
        },
        invoicedisputed: '',
        buyerinsolvency: '',
        invoicedisputedValue: '',
        buyerinsolvencyValue: '',
        comment: '',
        clientRefNumber: '',
        documents: [],
        collectedAmount: '',
        amountWithoutVAT: '',
        fundedAmount: this.cover.invoice.fundedAmountValue,
        deliveryDate: null
      }
      $('#coverinfocontainer').scrollTop(0)
      this.$store.dispatch('cover/setSubmittedClaim', submittedClaim)
    },
    initialize () {
      this.showDetailClaim = true
      this.showSubmitClaim = false
      this.showSubmitClaimSummary = false
      this.enablebloc()
      let submittedClaim = {
        buyer: {
          firstName: '',
          lastName: '',
          email: '',
          mobilePhone: '',
          officePhone: ''
        },
        seller: {
          firstName: '',
          lastName: '',
          email: '',
          mobilePhone: '',
          officePhone: ''
        },
        invoicedisputed: '',
        buyerinsolvency: '',
        invoicedisputedValue: '',
        buyerinsolvencyValue: '',
        comment: '',
        clientRefNumber: '',
        documents: [],
        collectedAmount: '',
        amountWithoutVAT: '',
        fundedAmount: this.cover.invoice.fundedAmountValue,
        deliveryDate: null
      }
      $('#coverinfocontainer').scrollTop(0)
      this.$store.dispatch('cover/setSubmittedClaim', submittedClaim)
    },
    initializeAndCloseExtendedMode () {
      this.$store.dispatch('cover/setExtendedMode', true)
      this.initialize()
    },
    disablebloc () {
      if (!$('#app').hasClass('disablebloc')) {
        $('#app').addClass('disablebloc')
      }
      if (!$('#coverbloc').hasClass('enablebloc')) {
        $('#coverbloc').addClass('enablebloc')
      }
    },
    enablebloc () {
      if ($('#app').hasClass('disablebloc')) {
        $('#app').removeClass('disablebloc')
      }
      if ($('#coverbloc').hasClass('enablebloc')) {
        $('#coverbloc').removeClass('enablebloc')
      }
    },
    async activateCover () {
      this.loadingActivate = true
      try {
        await coverApi.activateCover(this.cover.details.id)
        this.loadingActivate = false
        this.setSnackbarValues(true, 'success', this.activateCoverSuccessText)
        this.$router.push({ path: 'activated' })
        this.$store.dispatch('global/setSnackbar', this.snackbar)
        this.$store.dispatch('cover/setExtendedMode', true)
        this.$store.dispatch('coverquoted/getCoversQuoted', { coverStatusLabels: this.coverStatus })
        this.initialize()
      } finally {
        this.loadingActivate = false
      }
    },
    async rejectCover () {
      this.loadingActivate = true
      try {
        await coverApi.rejectCover(this.cover.details.id)
        this.setSnackbarValues(true, 'success', this.rejectCoverSuccessText)
        this.$router.push({ path: 'archived' })
        this.$store.dispatch('global/setSnackbar', this.snackbar)
        this.$store.dispatch('cover/setExtendedMode', true)
        this.$store.dispatch('coverquoted/getCoversQuoted', { coverStatusLabels: this.coverStatus })
        this.initialize()
      } finally {
        this.loadingActivate = false
      }
    },
    setSnackbarValues (show, color, text) {
      this.snackbar.show = show
      this.snackbar.color = color
      this.snackbar.text = text
    },
    async settleCover () {
      let success = await this.$parent.settleCover(this.cover.details.id)
      if (success) {
        this.$router.push({ path: 'settled' })
        this.$store.dispatch('cover/setExtendedMode', true)
        this.initialize()
        if (this.cover.invoice.status.toUpperCase() === 'Claimed'.toUpperCase()) {
          this.$store.dispatch('listcovertabs/updateCoversClaimedCount')
        }
      }
    }
  },
  components: {
    CoverDetails,
    SubmitClaim,
    SubmitClaimSummary
  },
  computed: {
    ...mapState('cover', ['cover', 'submittedClaim', 'coverStatus']),
    ...mapState('userdetails', ['userInfos']),
    canActivateCover: function () {
      return auth.hasCoverageAccess() && this.cover.invoice.statusCode.toUpperCase() === this.pendingStatus.toUpperCase()
    },
    canClaimCover: function () {
      let hasLegacyClaimAccess = auth.hasClaimAccess()
      let hasBuyerClaimAccess = auth.hasBuyerClaimAccess()
      return hasLegacyClaimAccess && !hasBuyerClaimAccess
    },
    canSettleCover: function () {
      return auth.hasCoverageAccess() && this.settleableStatuses.includes(this.cover.invoice.statusCode) && this.showDetailClaim
    },
    canClaimAndSettleCover: function () {
      return auth.hasClaimAccess() && auth.hasCoverageAccess() && this.claimableStatuses.includes(this.cover.invoice.statusCode) &&
            this.settleableStatuses.includes(this.cover.invoice.statusCode) && this.showDetailClaim
    }
  }
}
</script>
<style>
.custombtn {
  background-color: white !important;
  border-color:  var(--primary-color) !important;
  border: 1px solid;
  color:  var(--primary-color) !important;
}
.footeractionleft {
    padding-right: 10px;
}

.footeractionright {
    padding-left: 10px;
}

.coverinfocontainer{
 background-color: rgba(249, 250, 252, 1.0);
 margin-top: -38px;
 height: 900px;
 overflow-y: scroll;
 padding-bottom: 12px;
}

.coverinfodetails{
    padding-top: 49px;
    padding-right: 18px;
}

.theme--light.v-label {
 color: rgba(41, 42, 41, 1.0);
 font-size: 13px
}

.invoicedetails{
  padding-top: 42px;
  line-height: 24px;
}
.invoicevalue{
  line-height: 30px;
   display: grid;
}

.info-title {
    font-weight: 600;
}
.divider {
        padding-top: 5px;
}
.coverdetailsbloc{
    padding-top: 38px;
}

.coverdetailsbloccontent{
    padding-top: 15px;
}

.boldtitle{
    font-weight: bold;
    color: rgba(41, 42, 41, 1.0);
}
.sub-title-header{
  color: rgba(41, 42, 41, 1.0);
  font-size: 13px;
  font-weight: bold;
}
.coverfooterbloc{
    height: 80px;
    background-color: #ffffff;
}
.submitclaimbtnbloc{
    padding-top: 10px;
}
.coverbloc {
    border-style: solid;
    border-width: 1px;
    border-color: rgba(239, 242, 242, 1.0);
}
.invoicenumber {
    font-size: 18.0px;
    margin-bottom: 6px
}

.detailsinfo {
    padding-top: 38px;
}
</style>
